(function(){
'use strict';

/* V10 Custom Order UI polish. Core studio owns workflow; finance owns rewards; this file owns layout polish only. */
var STATES=new WeakMap();

function label(card,index){
  var a=card.querySelector('.zss-design-card-meta strong');
  var b=card.querySelector('.zss-design-card-meta small');
  var x=a?(a.textContent||'').trim():'Design '+(index+1);
  var y=b?(b.textContent||'').trim():'';
  return y?x+' — '+y:x;
}

function syncPicker(studio){
  var panel=studio.querySelector('[data-zss-step-panel="2"], [data-zss-panel="adjust"], .zss-panel-adjust');
  if(!panel) return;
  var cards=Array.from(studio.querySelectorAll('.zss-design-card'));
  var existing=panel.querySelector('.zss-v10-adjust-picker');
  if(!cards.length){if(existing) existing.hidden=true;return;}

  var target=panel.querySelector('.zss-adjust-design-summary, .zss-adjust-card, .zss-adjust-selected-design');
  var wrap=existing;
  if(!wrap){
    wrap=document.createElement('label');
    wrap.className='zss-v10-adjust-picker';
    wrap.innerHTML='<span>Design to adjust</span><select class="zss-v10-adjust-select" aria-label="Choose design to adjust"></select>';
    wrap.querySelector('select').addEventListener('change',function(){
      var index=parseInt(this.value,10)||0;
      studio.dataset.zssV10AdjustIndex=String(index);
      var card=Array.from(studio.querySelectorAll('.zss-design-card'))[index];
      if(card){
        var select=card.querySelector('.zss-design-select');
        if(select) select.click();
        setTimeout(function(){var tab=studio.querySelector('[data-zss-step-tab="2"]');if(tab) tab.click()},40);
      }
    });
  }
  wrap.hidden=false;
  if(target&&target.parentNode){
    if(wrap.parentNode!==target.parentNode||wrap.nextElementSibling!==target) target.parentNode.insertBefore(wrap,target);
  }else if(wrap.parentNode!==panel){
    panel.insertBefore(wrap,panel.firstChild);
  }

  var select=wrap.querySelector('select');
  var active=cards.findIndex(function(card){return card.classList.contains('is-active')||card.getAttribute('aria-current')==='true'});
  if(active<0){
    active=parseInt(studio.dataset.zssV10AdjustIndex,10);
    if(isNaN(active)||active<0||active>=cards.length) active=0;
  }
  var signature=cards.map(label).join('|');
  if(select.dataset.signature!==signature){
    select.innerHTML='';
    cards.forEach(function(card,index){
      var option=document.createElement('option');
      option.value=String(index);
      option.textContent=label(card,index);
      select.appendChild(option);
    });
    select.dataset.signature=signature;
  }
  select.value=String(active);
}

function addStyles(){
  var old=document.getElementById('tlc-v10-custom-order-final-polish');
  if(old) old.remove();
  var style=document.createElement('style');
  style.id='tlc-v10-custom-order-final-polish';
  style.textContent=`











body:has(.zss-integrated) [data-zss-studio] .zss-design-card{position:relative!important;display:grid!important;grid-template-columns:1fr!important;grid-template-areas:'identity' 'actions'!important;gap:7px!important;padding:9px 10px!important;min-height:0!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-select{grid-area:identity!important;width:100%!important;display:grid!important;grid-template-columns:42px minmax(0,1fr)!important;gap:8px!important;padding:0 36px 0 0!important;min-height:42px!important;align-items:center!important;text-align:left!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-select img{width:42px!important;height:42px!important;min-width:42px!important;border-radius:8px!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-card-meta{min-width:0!important;display:block!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-card-meta strong{display:block!important;font-size:13.5px!important;line-height:1.2!important;font-weight:650!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-card-meta small,body:has(.zss-integrated) [data-zss-studio] .zss-design-card-meta em{display:block!important;font-size:11.5px!important;line-height:1.3!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-card-actions{grid-area:actions!important;display:grid!important;grid-template-columns:minmax(145px,1fr) 92px 78px!important;grid-template-areas:'finish approval qty'!important;gap:7px!important;width:100%!important;align-items:center!important;padding:0!important;margin:0!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-finish{grid-area:finish!important;min-width:0!important;width:100%!important;margin:0!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-finish>span{display:none!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-finish select{width:100%!important;min-width:0!important;height:40px!important;min-height:40px!important;padding:0 34px 0 12px!important;font-size:13.5px!important;font-weight:600!important;line-height:1.2!important;border-radius:9px!important;white-space:nowrap!important;text-overflow:ellipsis!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-approval{grid-area:approval!important;width:92px!important;min-width:92px!important;height:40px!important;min-height:40px!important;margin:0!important;padding:0 8px!important;display:flex!important;align-items:center!important;justify-content:center!important;gap:5px!important;font-size:12.5px!important;white-space:nowrap!important;border-radius:9px!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-approval input{width:14px!important;height:14px!important;min-width:14px!important;margin:0!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-qty{grid-area:qty!important;width:78px!important;min-width:78px!important;height:40px!important;margin:0!important;display:grid!important;grid-template-columns:24px 30px 24px!important;align-items:stretch!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-qty>span{display:none!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-qty button,body:has(.zss-integrated) [data-zss-studio] .zss-design-qty input{height:40px!important;min-height:40px!important;padding:0!important;font-size:12px!important;text-align:center!important}
body:has(.zss-integrated) [data-zss-studio] .zss-design-remove{position:absolute!important;top:9px!important;right:9px!important;width:28px!important;height:28px!important;min-width:28px!important;min-height:28px!important;margin:0!important;padding:0!important;z-index:3!important;border-radius:999px!important;display:grid!important;place-items:center!important}
body:has(.zss-integrated) [data-zss-studio] .zss-v10-adjust-picker{display:grid!important;gap:5px!important;width:100%!important;margin:0 0 8px!important}
body:has(.zss-integrated) [data-zss-studio] .zss-v10-adjust-picker[hidden]{display:none!important}
body:has(.zss-integrated) [data-zss-studio] .zss-v10-adjust-picker>span{font-size:10.5px!important;line-height:1!important;text-transform:uppercase!important;letter-spacing:.04em!important;color:#6c665f!important}
body:has(.zss-integrated) [data-zss-studio] .zss-v10-adjust-select{width:100%!important;height:42px!important;min-height:42px!important;border:1px solid #d9cbb8!important;border-radius:9px!important;background:#fff!important;padding:0 34px 0 11px!important;font:600 13px/1.2 var(--font-body-family)!important;color:#2C2620!important}
@media(max-width:749px){body:has(.zss-integrated) [data-zss-studio] .zss-design-card{padding:9px!important;gap:8px!important}body:has(.zss-integrated) [data-zss-studio] .zss-design-select{padding-right:34px!important}body:has(.zss-integrated) [data-zss-studio] .zss-design-card-actions{grid-template-columns:minmax(0,1fr) 78px!important;grid-template-areas:'finish finish' 'approval qty'!important;gap:7px 8px!important}body:has(.zss-integrated) [data-zss-studio] .zss-design-approval{justify-self:start!important}body:has(.zss-integrated) [data-zss-studio] .zss-design-qty{justify-self:end!important}}
`;
  document.head.appendChild(style);
}

function schedule(studio){
  var state=STATES.get(studio);if(!state) return;
  clearTimeout(state.timer);
  state.timer=setTimeout(function(){syncPicker(studio)},0);
}

function init(studio){
  if(STATES.has(studio)) return;
  var state={timer:null,observer:null};
  STATES.set(studio,state);

  syncPicker(studio);
  var tray=studio.querySelector('.zss-design-tray');
  if(tray&&window.MutationObserver){
    state.observer=new MutationObserver(function(){schedule(studio)});
    state.observer.observe(tray,{childList:true,subtree:true});
  }
}

function boot(){
  addStyles();
  document.querySelectorAll('[data-zss-studio]').forEach(init);
}

function start(){setTimeout(boot,0)}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
document.addEventListener('shopify:section:load',function(){setTimeout(boot,0)});
})();

